import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    pageLoader: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        textAlign: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
    },
    pageLoaderImg: {
        maxWidth: 75,
    },
    pageLoaderBox: {
        padding: theme.spacing(2.5),
        margin: theme.spacing(2.5),
        width: 300,
        boxShadow: '0 0 5px 0 #00000030',
        textAlign: 'center'
    },
    pageLoaderBoxCode: {
        fontSize: 32,
        fontWeight: 'bold',
        color: theme.palette.error.main
    },
    pageLoaderBoxMessage: {
        fontSize: 18,
    }
}))